/**
 *-------------------------------------------
 * apis in client management page
 *-------------------------------------------
 */

import { postData } from '../../request'

export function insertUser(payload) {
    return postData('/api/admin/insertUser', payload)
}

export function updateUser(payload) {
    return postData('/api/admin/updateUser', payload)
}

export function deleteUser(payload) {
    return postData('/api/admin/deleteUsers', payload)
}

export function activeUser(payload) {
    return postData('/api/admin/activeUser', payload)
}

export function updateEmrgncyStop(payload) {
    return postData('/api/admin/updateEmrgncyStop', payload)
}

export function checkContractRepresentativeEmail(payload) {
    return postData('/api/admin/checkContractRepresentativeEmail', payload)
}

export function insertClient(payload) {
    return postData('/api/admin/insertClient', payload)
}

export function updateClient(payload) {
    return postData('/api/admin/updateClient', payload)
}

export function getALLClientList(payload) {
    return postData('/api/admin/getALLClientList', payload)
}

export function getALLUserList(payload) {
    return postData('/api/admin/getALLUserList', payload)
}

export function getUser(payload) {
    return postData('/api/admin/getUser', payload)
}

export function getSysClient(payload) {
    return postData('/api/admin/getSysClient', payload)
}

export function getMaster(payload) {
    return postData('/api/admin/getMaster', payload)
}

export function updateTerminated(payload) {
    return postData('/api/admin/updateTerminated', payload)
}
